// One-time API-key reveal (ggcoin.ai#279): mono display with a copy
// affordance. The plaintext secret is shown exactly once, so copying is the
// primary act — the button confirms with a transient "Copied" state.

import { createSignal, onCleanup } from "solid-js";

/** How long the copy button shows its confirmation before resetting. */
const COPY_FEEDBACK_MS = 1500;

export function SecretKey(props: { value: string }) {
  const [copied, setCopied] = createSignal(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  function copy() {
    void navigator.clipboard
      ?.writeText(props.value)
      .then(() => {
        setCopied(true);
        clearTimeout(timer);
        timer = setTimeout(() => setCopied(false), COPY_FEEDBACK_MS);
      })
      .catch(() => {});
  }
  onCleanup(() => clearTimeout(timer));
  return (
    <div class="secret-wrap">
      <pre class="secret">{props.value}</pre>
      <button type="button" class="ghost secret-copy" onClick={copy} aria-live="polite">
        {copied() ? "Copied" : "Copy key"}
      </button>
    </div>
  );
}
